import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import themeProps from "theme/themes";
import Message from "../Message";
import send from "assets/icons/send.svg";
import io, { Socket } from "socket.io-client";
import { useAppSelector } from "store/hooks";
import { IMessage } from "common/interfaces/IMessage";

interface ChatProps {
  chatId: string;
  title: string;
}

const Wrapper = styled.div`
  background-color: ${(state: themeProps) => state.theme.background.primary};
  border-radius: 0px 18px 18px 0px;
  width: 100%;
  height: 100%;
`;

const Header = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid
    ${(state: themeProps) => state.theme.border.secondary};
`;

const Title = styled.h2``;

// const ApplicationButton = styled.button`
//   background-color: transparent;
//   color: ${(state: themeProps) => state.theme.main.primary};
//   margin-left: auto;
//   border: none;
//   outline: none;
//   cursor: pointer;
// `;

const ChatWrapper = styled.div`
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BubblesWrapper = styled.div`
  height: calc(80vh - 70px);
  width: 100%;
  padding: 0 50px;
  overflow-y: scroll;
`;

const Form = styled.form`
  position: relative;
  width: 90%;
  height: 40px;
`;

const TextInput = styled.input`
  width: 100%;
  height: 100%;
  background-color: #e5e5e5;
  border-radius: 20px;
  justify-self: flex-end;
  padding: 3px 25px;
  border: none;
  outline: none;
`;

const SendButton = styled.button`
  position: absolute;
  right: 15px;
  top: 10px;
  background-image: url(${send});
  background-repeat: none;
  background-size: cover;
  background-position: center;
  border: none;
  outline: none;
  background-color: transparent;
  width: 18px;
  height: 20px;
  cursor: pointer;
`;

let socket: Socket;
const ENDPOINT = process.env.REACT_APP_BASE_URL;

const Chat = ({ chatId, title }: ChatProps) => {
  const { t } = useTranslation("application");
  const [messages, setMessages] = useState<any>([]);
  const [inputValue, setInputValue] = useState<string>("");
  const name = useAppSelector((state) => state.user.info?.name);
  const userId = useAppSelector((state) => state.user.auth?.userId);

  useEffect(() => {
    socket = io(ENDPOINT || "localhost:4000");
  }, []);

  useEffect(() => {
    setMessages([]);
    socket.emit("join", {
      name,
      chatId,
    });
  }, [chatId, name]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages((messages: any[]) => [...messages, message]);
    });
  }, []);

  const onSend = (e: any) => {
    e.preventDefault();
    if (inputValue) {
      socket.emit(
        "sendMessage",
        {
          chatId: chatId,
          name,
          senderId: userId,
          message: inputValue,
        },
        (res: any) => {
          setInputValue("");
        }
      );
    }
  };

  useEffect(() => {
    var div: any = document.getElementById("chat");
    div.scrollTop = div.scrollHeight - div.clientHeight;
  }, [messages]);

  return (
    <Wrapper>
      <Header>
        <Title>{title}</Title>
        {/* <ApplicationButton onClick={() => {}}>
          {t("viewApplication")}
        </ApplicationButton> */}
      </Header>
      <ChatWrapper>
        <BubblesWrapper id="chat">
          {messages &&
            messages.length > 0 &&
            messages.map((message: IMessage, index: any) => (
              <Message key={index} message={message} />
            ))}
        </BubblesWrapper>
        <Form>
          <TextInput
            value={inputValue}
            placeholder={t("chat:writeMessage")}
            onChange={(e: any) => {
              setInputValue(e.target.value);
            }}
          />
          <SendButton
            onClick={(e) => {
              onSend(e);
            }}
          />
        </Form>
      </ChatWrapper>
    </Wrapper>
  );
};

export default Chat;
